import { Stack } from "@mui/system";

import React from "react";

import { Typography } from "@mui/material";

import IgfdBlackLogo from "@dashboard/assets/images/logo/logo-name-black.png";

export const MobileOverlay = () => {
  return (
    <Stack
      sx={({ palette }) => ({
        alignItems: "center",
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: palette.background.default,
        padding: 6,
        paddingTop: 10,
        gap: 2,
      })}
    >
      <img src={IgfdBlackLogo} style={{ width: 170 }} />
      <Typography align="center">
        This application is not supported on mobile devices.
      </Typography>
    </Stack>
  );
};
